module.exports = __webpack_public_path__ + "img/Education_Single_Frame0001.6048f23a.jpg";